import { Typography } from "@mui/material";
import type { FC } from "react";

import type { IOutcomeConsensus } from "~/types/event";
import { getOutcomeSpreadRange } from "~/utils/dashboardPanel/getOutcomeSpreadCell";
import { formatSpreadRange } from "~/utils/dashboardPanel/panelCopy";

const RANGE_SEPARATOR = " – ";

interface ISpreadGroupedCellProps {
  outcome: IOutcomeConsensus | null;
}

export const SpreadGroupedCell: FC<ISpreadGroupedCellProps> = ({ outcome }) => (
  <Typography variant="caption" sx={{ fontWeight: 700 }}>
    {formatSpreadRange(getOutcomeSpreadRange(outcome), RANGE_SEPARATOR)}
  </Typography>
);
